<template>
    <v-dialog
        :value="display"
        max-width="800"
        persistent
    >
        <LoadingSendingMail :value="loadingMail" />
        <MessageOverlay ref="overlay"/>
        <v-card>
            <v-card-title>
                <span class="text-h5">Password reset request</span>
                <span class="mt-5">Enter your e-mail address to receive a password reset link.</span>
                <span >You will receive it only if email is associated with an existing account.</span>
            </v-card-title>
            <v-card-text class="px-2 px-sm-6">
                <v-form ref="form" v-model="emailValidation" lazy-validation>
                    <v-text-field
                        v-model="emailRequest"
                        required
                        outlined
                        :rules="emailRules"
                        :label="$vuetify.lang.t('$vuetify.account.requestNewPassword.email') + '*'"
                    ></v-text-field>
                </v-form>

                
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    :disabled="!emailValidation"
                    :class="{ 'gradient-wintech': (emailValidation) }"
                    @click="validRequestNewPasswordDialog"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $vuetify.lang.t('$vuetify.account.requestNewPassword.validate') }}
                </v-btn>
                <v-btn
                    color="error"
                    @click="cancelRequestNewPasswordDialog"
                >
                    <v-icon left>mdi-cancel</v-icon>
                    {{ $vuetify.lang.t('$vuetify.account.requestNewPassword.cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
        
</template>
<script>
import axios from 'axios';
import LoadingSendingMail from '@/components/Overlay/LoadingSendingMail.vue';
import MessageOverlay from '@/components/Overlay/MessageOverlay.vue'
export default {
    name: "RequestNewPassword",
    components: {LoadingSendingMail, MessageOverlay},
    props: {
        display: Boolean
    },
    data() {
        return {
            emailRequest: "",
            emailRules: [
                v => !!v || 'Email is required',
                 v => /.+@.+\..+/.test(v) || 'Email must be valid',
            ],
            emailValidation: true,
            loadingMail: false,
        };
    },

    methods: {
        async validRequestNewPasswordDialog() {
            try {
                if(this.$refs.form.validate()){
                    this.loadingMail=true;
                    const res = await axios.post('login/requestNewPassword/'+ this.emailRequest);
                    if (res.status == 200) {
                        this.emailProp = "";
                        this.newPass = {};
                        this.confirmationPass = {};
                        this.$emit("valid");
                        this.loadingMail=false;
                    } 
                    
                }
                
            } catch(error) {
                if ('response' in error && error.response.status === 409) this.isNewEmail = false;
                else {
                    this.showOverlay("error", error);
                }
            }
            
        },
        cancelRequestNewPasswordDialog() {
            this.emailProp = "";
            this.newPass = {};
            this.confirmationPass = {};
            this.$emit("cancel");
        },
    },
    watch: {
        loadingMail (val) {
            val && setTimeout(() => {
                this.emailProp = "";
                this.newPass = {};
                this.confirmationPass = {};
                this.$emit("valid");
                this.loadingMail=false;
            }, 3200) //previous test compare to real email sending
        },
    },
};
</script>